import React from "react"
import PropTypes from "prop-types"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

import withRewardOnChange from "./withRewardOnChange"

const PROPERTY = "header"

export const schema = (required) => Validation.string(required ? "This is required" : null).max(44)

const Header = ({reward, onChange, required, label, referenceData, ...props}) => {
  return (
    <Input
      name={PROPERTY}
      value={reward[PROPERTY]}
      onChange={(value) => onChange(reward, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      validation={schema(required)}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

Header.propTypes = {
  reward: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
}

Header.defaultProps = {
  required: true,
  placeholder: "",
  label: "Header:",
  id: "header"
}

export default withRewardOnChange(Header)
